import { mapRates } from './services/map-rates/map-rates.js'
import { convert } from './services/convert/convert.js'

export default class CurrenciesClient {
  // constructor () {}

  convert (valueToConvert, date, pairCodes, ratesMap) {
    return convert(valueToConvert, date, pairCodes, ratesMap)
  }

  mapRates (rates) {
    return mapRates(rates)
  }
}
